import type { ComparedPlayer } from './api';

export interface PreviewModelSignalContract {
  core: number;
  benchmark: number | null;
  delta: number | null;
  calibratedEnsemble: number | null;
  calibrationStatus: 'PENDING';
  model: 'BRAMX_CORE_XPTS_V0_3_7';
}

export function previewModelSignalContract(signals: ComparedPlayer['modelSignals']): PreviewModelSignalContract {
  return {
    core: signals.bramxCoreXpts,
    benchmark: signals.fplBenchmarkXpts,
    delta: signals.fplBenchmarkXpts === null ? null : signals.bramxCoreXpts - signals.fplBenchmarkXpts,
    calibratedEnsemble: signals.calibratedEnsembleXpts,
    calibrationStatus: signals.calibrationStatus,
    model: signals.model,
  };
}
